import '../styles/loading.css';

export default function Loading(){

    return(
            <div className="loading-screen">
                <div className="loader"></div>
            </div>
    )
};